var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboardWrap full"}},[_c('ServicePoint')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }